module.exports = __webpack_public_path__ + "static/media/1_A1_27.eb6c257d.png";